var map = {
	"./count-1.mp3": 381,
	"./count-10.mp3": 382,
	"./count-2.mp3": 383,
	"./count-3.mp3": 384,
	"./count-4.mp3": 385,
	"./count-5.mp3": 386,
	"./count-6.mp3": 387,
	"./count-7.mp3": 388,
	"./count-8.mp3": 389,
	"./count-9.mp3": 390,
	"./good-luck.mp3": 391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 876;